import React from 'react';
import '../style/articleHeader.scss';

import { FacebookShareButton, FacebookIcon } from 'react-share';

export const ArticleHeader = ({ tag, title, id, time }) => {
  return (
    <>
      <div className="col-sm-12">
        <div className="kgen-article-header-tag">{tag == 'NEWS' ? 'LAJM' : 'EVENT'}</div>
      </div>
      <div className="kgen-article-header">
        <div className="col-sm-12 col-lg-12">
          <div className="kgen-article-header-title">{title}</div>
        </div>
        <div className="col-sm-12 col-lg-12">
          <div className="kgen-article-time">
            <div className="kgen-article-time-icon">
              <img src="/images/icon-clock.png" />
            </div>
            <div className="kgen-article-time-text">{time}</div>
            <div className="kgen-share-btn">
              <FacebookShareButton url={'https://kosovogenu.com/' + id + '/' + title?.replace(' ', '_')} quote={title}>
                <FacebookIcon size={18} round={true} />
              </FacebookShareButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
